import { render, staticRenderFns } from "./PICDipendenti.vue?vue&type=template&id=72f7ae7c&scoped=true"
import script from "./PICDipendenti.vue?vue&type=script&lang=js"
export * from "./PICDipendenti.vue?vue&type=script&lang=js"
import style0 from "./PICDipendenti.vue?vue&type=style&index=0&id=72f7ae7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7ae7c",
  null
  
)

export default component.exports